//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TopSwiper from './_swiper'
import TopTabs from './_top_tabs'
import ListEntry from './_list_entry'
import HomeService from '@/service/homepage'
import Col1_3 from './_col_1_3'
import List3 from './_list_3'

import Consultants from './_consultants'
import list_mixin from './_mixins/list'
import pull_up_mixin from '@/common/mixins/pull_up'
import { checkSessionStatus, reauth, session } from '@/common/utils/ajax'
import { UserLog } from '@/utils/log'
import Service from '@/service'
const isProd = process.env.NODE_ENV === 'production'
export default {
    name: 'Home',
    mixins: [
        list_mixin,
        pull_up_mixin
    ],
    components: {
        TopTabs,
        TopSwiper,
        ListEntry,
        Col1_3,
        List3,
        Consultants,
    },
    data () {
        return {
            query: '',
            dashboard: {},
            hot: {
                col_1: [],
                col_3: []
            },

            forthcoming_sale: {
                col_1: [],
                col_3: []
            },

            page: 1,

            latest_opening: [],
            latest_lot_number: [],
            surplus: [],
            surplus_loading: true,

            excellent_consultants: [],
            bottom_config: {
                pullText: '',
                triggerText: '',
                loadingText: '加载中...',
                doneText: '没有更多了。。。',
                failText: '加载失败',
                loadedStayTime: 400,
                stayDistance: 50,
                triggerDistance: 200
            }
        }
    },
    mounted () {
        this.getData()
    },
    methods: {
        async getData () {
            console.log('dashboard', this.dashboard)
            this.dashboard = await HomeService.getDashboard()
            console.log('dashboard', this.dashboard)
            this.getHot()
            this.page = 1
            this.getBuildings('最新取证', 'latest_opening', Math.max(this.dashboard.today_opening, 3))
            this.getSurplus()
            const data = await Service.getUserInfo()
            UserLog.userLogin()
        },
        getHot () {
            HomeService.getRecommendBuilding('hot', {
                limit: 4
            }).then(data => {
                this.hot = data || []
                this.loading = false
                this.page_loading = false
            }).then(() => {
                this.getConsultants()
                this.getRecommendBuildings('forthcoming_sale')
                this.getBuildings('最新摇号', 'latest_lot_number', 3)
            }).catch((err) => {
                console.error(err)
                this.loading = false
            })
        },
        getRecommendBuildings (status) {
            const exclude_targetable_ids = this.getHotIds()
            HomeService.getRecommendBuilding(status, {
                limit: 4,
                exclude_targetable_ids
            }).then((data) => {
                this[status] = data || []
            })
        },
        getHotIds () {
            return Object.keys(this.hot)
                .reduce((ids, key) => {
                    ids.push(...this.hot[key].map(({building_id}) => building_id))
                    return ids
                }, []).join(',')
        },
        getBuildings (status, key, per) {
            HomeService.getBuildings(status, per).then((data) => {
                this[key] = data || []
            })
        },
        getConsultants () {
            HomeService.getConsultants().then((data) => {
                this.excellent_consultants = data
            })
        },
        onPullUp () {
            if (!this.surplus_loading) {
                this.page++
                this.getSurplus()
            }
        },
        getSurplus() {
            this.surplus_loading = true
            Service.getBuildings({
                page: this.page,
                per: 30,
                status: '在售'
            }).then(({ items }) => {
                this.surplus_loading = false
                if (this.page === 1) {
                    this.surplus = items
                } else {
                    const ids = this.surplus.map(({ building_id }) => building_id)
                    const new_items = items.reduce((prev, item) => {
                        if (!ids.includes(item.building_id)) {
                            prev.push(item)
                        }
                        return prev
                    }, [])
                    this.surplus.push(...new_items)
                }
            })
        },
        call () {
            window.location.href = `tel:17381915036`
        }
    }
}
